module.exports = __webpack_public_path__ + "img/frame (170).b9194831.jpg";